/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressRelease,
    PressReleaseFromJSON,
    PressReleaseFromJSONTyped,
    PressReleaseToJSON,
} from './PressRelease';

/**
 * 
 * @export
 * @interface BookmarkedPressReleasesResponseAllOfData
 */
export interface BookmarkedPressReleasesResponseAllOfData {
    /**
     * 保存済みプレスリリース一覧
     * @type {Array<PressRelease>}
     * @memberof BookmarkedPressReleasesResponseAllOfData
     */
    pressReleases: Array<PressRelease>;
    /**
     * 次のデータを取得する開始点となる識別子
     * @type {string}
     * @memberof BookmarkedPressReleasesResponseAllOfData
     */
    nextCursor?: string;
}

export function BookmarkedPressReleasesResponseAllOfDataFromJSON(json: any): BookmarkedPressReleasesResponseAllOfData {
    return BookmarkedPressReleasesResponseAllOfDataFromJSONTyped(json, false);
}

export function BookmarkedPressReleasesResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookmarkedPressReleasesResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(PressReleaseFromJSON)),
        'nextCursor': !exists(json, 'next_cursor') ? undefined : json['next_cursor'],
    };
}

export function BookmarkedPressReleasesResponseAllOfDataToJSON(value?: BookmarkedPressReleasesResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(PressReleaseToJSON)),
        'next_cursor': value.nextCursor,
    };
}

